module.exports = __webpack_public_path__ + "img/lb-suduko.2691c55d.svg";